import { react2panel } from 'common/util/react2panel';

// eslint-disable-next-line import/no-cycle
import { SegmentBucketPane } from './index';
export const SegmentBucketPaneEl = react2panel("segment-bucket-pane", SegmentBucketPane, {});